/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlEmailDeliveryStatus
 */
export interface ControlEmailDeliveryStatus {
    /**
     * 
     * @type {number}
     * @memberof ControlEmailDeliveryStatus
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof ControlEmailDeliveryStatus
     */
    success: number;
    /**
     * 
     * @type {number}
     * @memberof ControlEmailDeliveryStatus
     */
    bounced: number;
    /**
     * 
     * @type {number}
     * @memberof ControlEmailDeliveryStatus
     */
    failed: number;
    /**
     * 
     * @type {number}
     * @memberof ControlEmailDeliveryStatus
     */
    pending: number;
}

/**
 * Check if a given object implements the ControlEmailDeliveryStatus interface.
 */
export function instanceOfControlEmailDeliveryStatus(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "success" in value;
    isInstance = isInstance && "bounced" in value;
    isInstance = isInstance && "failed" in value;
    isInstance = isInstance && "pending" in value;

    return isInstance;
}

export function ControlEmailDeliveryStatusFromJSON(json: any): ControlEmailDeliveryStatus {
    return ControlEmailDeliveryStatusFromJSONTyped(json, false);
}

export function ControlEmailDeliveryStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEmailDeliveryStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': json['total'],
        'success': json['success'],
        'bounced': json['bounced'],
        'failed': json['failed'],
        'pending': json['pending'],
    };
}

export function ControlEmailDeliveryStatusToJSON(value?: ControlEmailDeliveryStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'success': value.success,
        'bounced': value.bounced,
        'failed': value.failed,
        'pending': value.pending,
    };
}

